module.exports = __webpack_public_path__ + "img/sort-icon-desc.94eb803e.svg";